import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    { paint: 'trunk', d: 'M-1.5,0.5h1.5v0.5h-1.5zM0.5,0.5h2v0.5h-2z' },
    { paint: 'bareBranch', d: 'M-0.5,-3h1v3.5h-1zM0,0.5h0.5v0.5h-0.5z' },
    {
      paint: [
        ['parasolRed', 0.7],
        ['trunk', 0.3],
      ],
      d: 'M0,-5.5h0.5v0.5h-0.5zM1.5,-4.5h0.5v0.5h-0.5zM1.5,-4h1.5v0.5h-1.5zM1,-3.5h2v0.5h-2z',
    },
    {
      paint: 'parasolRed',
      d: 'M0.5,-5.5h1v0.5h-1zM-1,-5h0.5v0.5h-0.5zM0.5,-5h2v0.5h-2zM-1.5,-4.5h0.5v0.5h-0.5zM1,-4.5h0.5v1h-0.5zM2,-4.5h1v0.5h-1zM-3,-3.5h0.5v0.5h-0.5zM-2,-3.5h0.5v0.5h-0.5z',
    },
    {
      paint: [
        ['parasolRed', 0.62],
        ['parasolStripe', 0.38],
      ],
      d: 'M-1.5,-5.5h1.5v0.5h-1.5zM-2,-5h1v0.5h-1zM-3,-4.5h1.5v0.5h-1.5zM-1,-4.5h0.5v0.5h-0.5zM0.5,-4.5h0.5v0.5h-0.5zM-3,-4h2v0.5h-2zM-2.5,-3.5h0.5v0.5h-0.5zM-1.5,-3.5h2.5v0.5h-2.5z',
    },
    { paint: 'parasolStripe', d: 'M-0.5,-5h1v1h-1zM-1,-4h2v0.5h-2z' },
  ],
  pixels: 73,
};
const variant1: PixelSprite = {
  layers: [
    { paint: 'trunk', d: 'M-1.5,0.5h1.5v0.5h-1.5zM0.5,0.5h2v0.5h-2z' },
    { paint: 'bareBranch', d: 'M-0.5,-3h1v3.5h-1zM0,0.5h0.5v0.5h-0.5z' },
    {
      paint: [
        ['parasolBlue', 0.7],
        ['trunk', 0.3],
      ],
      d: 'M-0.5,-6h1v0.5h-1zM1.5,-4.5h1v0.5h-1zM1.5,-4h1.5v0.5h-1.5zM1,-3.5h2.5v0.5h-2.5z',
    },
    {
      paint: 'parasolBlue',
      d: 'M-1,-5.5h0.5v0.5h-0.5zM0.5,-5.5h1.5v0.5h-1.5zM-1.5,-5h1v0.5h-1zM0.5,-5h2v0.5h-2zM-1.5,-4.5h0.5v0.5h-0.5zM1,-4.5h0.5v0.5h-0.5zM2.5,-4.5h0.5v0.5h-0.5zM3,-4h0.5v0.5h-0.5zM-3.5,-3.5h1v0.5h-1zM-2,-3.5h0.5v0.5h-0.5z',
    },
    {
      paint: [
        ['parasolBlue', 0.62],
        ['parasolStripe', 0.38],
      ],
      d: 'M-2,-5.5h1v0.5h-1zM-0.5,-5.5h1v0.5h-1zM-2.5,-5h1v0.5h-1zM-3,-4.5h1.5v0.5h-1.5zM-1,-4.5h0.5v0.5h-0.5zM0.5,-4.5h0.5v0.5h-0.5zM-3.5,-4h2.5v0.5h-2.5zM1,-4h0.5v0.5h-0.5zM-2.5,-3.5h0.5v0.5h-0.5zM-1.5,-3.5h1v0.5h-1zM0.5,-3.5h0.5v0.5h-0.5z',
    },
    { paint: 'parasolStripe', d: 'M-0.5,-5h1v1h-1zM-1,-4h2v0.5h-2zM-0.5,-3.5h1v0.5h-1z' },
  ],
  pixels: 82,
};
const variant2: PixelSprite = {
  layers: [
    { paint: 'trunk', d: 'M-1.5,0.5h1.5v0.5h-1.5zM0.5,0.5h2v0.5h-2z' },
    { paint: 'bareBranch', d: 'M-0.5,-3h1v3.5h-1zM0,0.5h0.5v0.5h-0.5z' },
    {
      paint: [
        ['parasolYellow', 0.7],
        ['trunk', 0.3],
      ],
      d: 'M1.5,-4h1v0.5h-1zM1,-3.5h2v0.5h-2z',
    },
    {
      paint: 'parasolYellow',
      d: 'M-1,-5h0.5v0.5h-0.5zM0.5,-5h1.5v0.5h-1.5zM1,-4.5h2v0.5h-2zM1,-4h0.5v0.5h-0.5zM2.5,-4h0.5v0.5h-0.5zM-3,-3.5h0.5v0.5h-0.5zM-2,-3.5h0.5v0.5h-0.5z',
    },
    {
      paint: [
        ['parasolStripe', 0.38],
        ['parasolYellow', 0.62],
      ],
      d: 'M-1.5,-5h0.5v0.5h-0.5zM-0.5,-5h1v0.5h-1zM-2.5,-4.5h2v0.5h-2zM0.5,-4.5h0.5v0.5h-0.5zM-3,-4h2v0.5h-2zM-2.5,-3.5h0.5v0.5h-0.5zM-1.5,-3.5h2.5v0.5h-2.5z',
    },
    { paint: 'parasolStripe', d: 'M-0.5,-4.5h1v0.5h-1zM-1,-4h2v0.5h-2z' },
  ],
  pixels: 64,
};
export const sprites: readonly PixelSprite[] = [variant0, variant1, variant2];
